import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import AuthCallbackHandler from "./components/AuthCallbackHandler";
import AuthViewModal from "./components/AuthViewModal";
import "./App.css";
import Info from "./components/Info";
import RecipeView from "./components/RecipeView";
import Pantry from "./components/Pantry";
import FooterNav from "./components/FooterNav";
import Profile from "./components/Profile";
import SignedOutView from "./components/SignedOutView";
import ChooseProfileName from "./components/ChooseProfileName";
import SavedRecipes from "./components/SavedRecipes";
import ShoppingListView from "./components/ShoppingListView";
import { supabase } from "./supabaseClient";
import { ShoppingListProvider } from "./context/ShoppingListProvider";
import { IngredientsProvider } from "./context/IngredientsProvider";

const App: React.FC = () => {
  const navigate = useNavigate();
  const [session, setSession] = useState<any>(null);
  const [showLogin, setShowLogin] = useState(false);
  const [showChooseProfile, setShowChooseProfile] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    const getSession = async () => {
      const { data: sessionData } = await supabase.auth.getSession();
      setSession(sessionData.session);

      const { data: authListener } = supabase.auth.onAuthStateChange(
        (_event, session) => {
          setSession(session);
        }
      );

      return () => {
        authListener?.subscription?.unsubscribe();
      };
    };

    getSession();
  }, []);

  useEffect(() => {
    const redirectToProfileCreation = async () => {
      if (!session?.user) return;

      const { data, error } = await supabase
        .from("users")
        .select("id")
        .eq("id", session.user.id)
        .maybeSingle();

      if (!data || error) {
        console.log("🔁 Näytetään profiilinimen valinta -modaali");
        setShowChooseProfile(true);
      }
    };

    redirectToProfileCreation();
  }, [session]);

  return (
    <IngredientsProvider>
      <ShoppingListProvider>
        <>
          {showLogin && <AuthViewModal onClose={() => setShowLogin(false)} />}
          {showChooseProfile && (
            <ChooseProfileName
              onSuccess={() => setShowChooseProfile(false)}
              onClose={async () => {
                await supabase.auth.signOut();
                setSession(null);
                setShowChooseProfile(false);
                navigate("/signed-out");
              }}
            />
          )}

          <main className="main-container">
            <div className="page-content">
              <Routes>
                <Route path="/auth" element={<AuthCallbackHandler />} />
                <Route path="/signed-out" element={<SignedOutView />} />
                <Route path="/recipes" element={<RecipeView />} />
                <Route path="/info" element={<Info />} />
                <Route path="/storage" element={<Pantry session={session} />} />
                <Route path="/saved" element={<SavedRecipes />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/shopping" element={<ShoppingListView />} />
                <Route path="/" element={<RecipeView />} />
              </Routes>
            </div>

            <FooterNav
              isLoggedIn={!!session}
              setShowLogin={setShowLogin}
              showMenu={showMenu}
              setShowMenu={setShowMenu}
            />
          </main>
        </>
      </ShoppingListProvider>
    </IngredientsProvider>
  );
};

export default App;
